<ng-container
  *ngTemplateOutlet="src ? srcTpl : useIconPlaceholder ? iconTpl : placeholder"
></ng-container>

@if (channel || displayIcons) {
  <div class="channel-icons">
    @if (iconNames[channel]) {
      <span [ngClass]="iconNames[channel]"></span>
    }
  </div>
}

<ng-template #placeholder>
  <div class="avatar-placeholder">{{ firstLetterOfName | titlecase }}</div>
</ng-template>

<ng-template #srcTpl>
  <div class="user-thumbnail" [ngStyle]="{ 'background-image': 'url(' + src + ')' }"></div>
</ng-template>

<ng-template #iconTpl>
  <span class="hosty-icon-user"></span>
</ng-template>
